module.exports =
  '_CONFIRMATION':
    'NEW':
      'TITLE': 'Email address confirmation'
      'CURRENT_EMIL': 'Registered email address'
      'CONFIRMATION_MSG': 'Follow these steps to complete your email confirmation.'
      'INSTRUCTION_STEP1': 'A confirmation email will be sent to you after you tap "Send" button.'
      'INSTRUCTION_STEP2': 'Click the link written on the confirmation email.'
      'INSTRUCTION_STEP3': 'Then, the procedures is completed.'
      'SEND': 'Send ( A confirmation email will be sent to you. )'
      'CHANGE_EMAIL_NOW': 'I want to change my email address.'
      'EMAIL_SENT': 'Confirmation email has been sent, please check your inbox.'
    'EDIT':
      'TITLE': 'Confirmed'
      'SUCCESS': 'Email confirmation has been completed.'
      'INVALID': 'Invalid token. Please check again.'
      'DASHBOARD': 'Back to dashboard'
    'NOTIFICATION':
      'TEXT': 'Please confirm your account email'
    'ACCOUNT_PAGE':
      'TEXT': 'Please complete email confirmation.'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/email-confirmation/i18n/en.coffee